"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const Bar = styled_1.default("div")({
    display: "grid",
    width: "100%",
    padding: 0,
    " > *": {
        display: "flex",
        alignItems: "center",
    },
}, ({ theme }) => {
    return {
        height: theme.titleHeight,
        gridTemplateColumns: `${theme.sidebarWidth}px auto 250px`,
        backgroundColor: theme.color.background.dark,
        color: theme.color.white,
        " > *": {
            height: theme.titleHeight,
        },
    };
});
const StartContainer = styled_1.default("div")();
const CenterContainer = styled_1.default("div")();
const EndContainer = styled_1.default("div") `
  display: flex;
  justify-content: flex-end;
`;
const HeaderBar = (_a) => {
    var { logo, main, end } = _a, props = __rest(_a, ["logo", "main", "end"]);
    return (React.createElement(Bar, Object.assign({}, props),
        React.createElement(StartContainer, null, logo),
        React.createElement(CenterContainer, null, main),
        React.createElement(EndContainer, null, end)));
};
exports.default = HeaderBar;
//# sourceMappingURL=HeaderBar.js.map